import { rootApi } from '../rootApi';

/**
 * LMS Eğitim Planlamaları — `/v1.0/LmsCatalogPlanning`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §8.
 *
 * Katalogdaki bir eğitim için birden fazla planlama (oturum) açılabilir. Silme, planlamaya
 * atanmış eğitmenleri de (backend tarafında) pasife çektiği için `LmsPlanningInstructor` tag'i
 * de invalidate edilir (doc §8.6).
 */
export const lmsCatalogPlanningApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsCatalogPlannings: builder.query({
            query: ({ trainingId, trainingCode, planningLocation, startDateFrom, startDateTo, status, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsCatalogPlanning/GetList',
                method: 'POST',
                body: {
                    trainingId: trainingId ?? null,
                    trainingCode: trainingCode || null,
                    planningLocation: planningLocation || null,
                    startDateFrom: startDateFrom || null,
                    startDateTo: startDateTo || null,
                    status: status ?? null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsCatalogPlanning']
        }),

        getLmsCatalogPlanningById: builder.query({
            query: (id) => ({
                url: 'v1/LmsCatalogPlanning/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsCatalogPlanning']
        }),

        addLmsCatalogPlanning: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsCatalogPlanning/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsCatalogPlanning']
        }),

        updateLmsCatalogPlanning: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsCatalogPlanning/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsCatalogPlanning']
        }),

        deleteLmsCatalogPlanning: builder.mutation({
            query: (id) => ({
                url: `v1/LmsCatalogPlanning/${id}`,
                method: 'DELETE'
            }),
            // Silme, planlamaya atanmış eğitmenleri de pasife çeker (doc §8.6)
            invalidatesTags: ['LmsCatalogPlanning', 'LmsPlanningInstructor']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsCatalogPlanningsQuery,
    useGetLmsCatalogPlanningByIdQuery,
    useAddLmsCatalogPlanningMutation,
    useUpdateLmsCatalogPlanningMutation,
    useDeleteLmsCatalogPlanningMutation
} = lmsCatalogPlanningApi;
